import moment from 'moment'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {useFormContext} from 'react-hook-form'
import {
  ResponseTotalScanActivity,
  ScanActivityDto,
  ScanActivityResponse,
} from '../../../../model/cleaningStatus.model'
import {CLEANING_STATUS_SERVICES} from '../../../../services/cleaning-status.service'
import {KTableLoading} from '../../../../../../components/UI'

export const ModalObservationDetail = () => {
  const {setValue, watch} = useFormContext()
  const showModalObservationDetails = watch('showModalObservationDetails')
  const observationId = watch('observationId')
  const [data, setData] = useState<any>(null)
  const [photoUrl, setPhotoUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handleClose = () => {
    setValue('showModalObservationDetails', false)
    setData(null)
    setPhotoUrl(null)
  }

  useEffect(() => {
    if (observationId && showModalObservationDetails) {
      getObservationDetail()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModalObservationDetails, observationId])

  const getObservationDetail = async () => {
    try {
      setLoading(true)
      const [infoResponse, photoResponse] = await Promise.all([
        CLEANING_STATUS_SERVICES.getListEscaneoActividadById(observationId),
        CLEANING_STATUS_SERVICES.downloadDocument(observationId),
      ])
      if (!infoResponse.data?.error) {
        setData(infoResponse.data.data)
      }
      if (photoResponse?.data && !photoResponse.data.error) {
        setPhotoUrl(photoResponse.data.Url)
      } else {
        setPhotoUrl(null)
      }
    } catch (error) {
      console.error('Error obteniendo detalle de observación', error)
    } finally {
      setLoading(false)
    }
  }

  // cleanup blob url
  //   useEffect(() => {
  //     return () => {
  //       if (photoUrl) {
  //         URL.revokeObjectURL(photoUrl)
  //       }
  //     }
  //   }, [photoUrl])

  return (
    <Modal
      className='modal fade'
      show={showModalObservationDetails}
      dialogClassName='modal-md'
      aria-hidden='true'
      size='xl'
      centered
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Información de Observación</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>

        <div className='modal-body'>
          {loading && <KTableLoading />}

          {!loading && (
            <>
              <div className='mb-4'>
                <h6 className='fw-bold'>Motivo</h6>
                <p className='mb-3'>{data?.MotivoObservado || '-'}</p>

                <h6 className='fw-bold'>Comentarios</h6>
                <p className='mb-3'>{data?.Comentario || '-'}</p>
              </div>

              <div className='mb-3'>
                <h6 className='fw-bold'>Foto</h6>

                {photoUrl ? (
                  <img
                    src={photoUrl}
                    alt='observación'
                    className='img-fluid rounded'
                    style={{maxHeight: '350px', objectFit: 'contain'}}
                  />
                ) : (
                  <span className='text-muted'>Sin imagen disponible</span>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </Modal>
  )
}
